import { render, staticRenderFns } from "./Destination.vue?vue&type=template&id=61cdce10"
import script from "./Destination.vue?vue&type=script&setup=true&lang=js"
export * from "./Destination.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Destination.vue?vue&type=style&index=0&id=61cdce10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports